import mixpanel from "mixpanel-browser";
let environmentToken;

if (
  window.location.hostname.toLowerCase() === "platform.zonkafeedback.com" ||
  window.location.hostname.toLowerCase() === "demo.zonkafeedback.com"
) {
  environmentToken = "edd455c4e89d80f974f388e06fd5fab4";
} else if (window.location.hostname.toLowerCase() === "web.zonkasurvey.com") {
  environmentToken = "163a6fd2486a41abb77fb03436ad38d0";
} else if (
  window.location.hostname.toLowerCase() === "stgfrontend.zonkafeedback.com"
) {
  environmentToken = "b7c0204f665ceef7c518e72f86bf7413";
} else if (window.location.hostname.toLowerCase() === "localhost") {
  environmentToken = "163a6fd2486a41abb77fb03436ad38d0";
}

mixpanel.init(environmentToken);

export const identify = id => {
  mixpanel.identify(id);
};

export const customTrack = (
  name,
  props,
  enableUserProp = "",
  userPropdata = {}
) => {
  if (enableUserProp) initProcedure(userPropdata);
  mixpanel.track(name, props);
};

export const people = props => {
  mixpanel.people.set(props);
};
export const peopleSetOnce = props => {
  mixpanel.people.set_once(props);
};

const initProcedure = (userPropdata = {}) => {
  const uniqueKey = window.localStorage.getItem("defaultId");
  identify(uniqueKey ? uniqueKey : "def" + Date.now().toString());
  var prop;
  prop = {
    $email: "New Webex User"
  };
  peopleSetOnce(prop);
};



// WEBPACK FOOTER //
// ./src/components/Mixpanel/mixPanelFunctions.js